import React, { PropsWithChildren } from 'react';
import loginImage from '../../../assets/ecosconnect-login.jpeg';
import { Box, Flex } from 'rebass';

/**
 * @component for auth page skeleton
 */
const AuthPageSkeleton: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <Flex sx={{ height: 'vh', width: 'vw' }}>
      <Flex
        flexGrow={1}
        alignItems="center"
        padding="7"
        maxWidth={420}
        width="100%"
      >
        {children}
      </Flex>
      <Box
        sx={{
          backgroundSize: 'cover',
          backgroundImage: `url(${loginImage})`,
          backgroundPosition: 'center',
          flexGrow: 1,
          flexShrink: 1,
        }}
      />
    </Flex>
  );
};

export default AuthPageSkeleton;
